document.addEventListener('DOMContentLoaded', function() {
  // DOM element selections
  const customiserWrapper = document.querySelector('.customiser-wrapper');
  const customerID = customiserWrapper.getAttribute('data-customer-id') || null;
  
  const seriesSelector = document.querySelector('select[name="series-selector"]');
  const thumbGroups = document.querySelectorAll('.thumb-group');
  const thumbItems = document.querySelectorAll('.thumb-item');

  const klaviyoFormCard = document.querySelector('.klaviyo-form-card .klaviyo-form');

  const buttonCartCount = document.querySelector('#button-cart-count');

  const watchPreviewImage = document.querySelector('.watch-preview');
  const strapPreviewImage = document.querySelector('.strap-preview');
  const saveButton = document.querySelector('.trigger-save-wishlist');

  const prevSelectionsSection = document.getElementById('customer-prev-selections');
  const prevSelections = prevSelectionsSection?.querySelectorAll('.previous-selection-item');

  const customiserInspiration = document.querySelector('.customiser-inspiration-wrapper');
  const customiserInspirationItems = customiserInspiration?.querySelectorAll('.customiser-inspiration-item');

  // Sticky element detection
  const customiserPreviewWrapper = document.querySelector('.customiser-preview-wrapper');
  
  // Monitor sticky element position during scroll
  if (customiserPreviewWrapper) {
    let isAtTop = false;
    
    window.addEventListener('scroll', () => {
      const rect = customiserPreviewWrapper.getBoundingClientRect();
      const isCurrentlyAtTop = rect.top <= 0;
      
      // Add/remove class based on sticky state
      if (isCurrentlyAtTop) {
        customiserPreviewWrapper.classList.add('sticky-at-top');
      } else {
        customiserPreviewWrapper.classList.remove('sticky-at-top');
      }
      
      isAtTop = isCurrentlyAtTop;
    });
  }

  // State variables
  let activeSeries = document.querySelector('.series-selector')?.value;
  let activeWatchID = document.querySelector('.watch-group.active .thumb-item.active')?.dataset.id;
  let activeStrapID = document.querySelector('.strap-group.active .thumb-item.active')?.dataset.id;
  let currentStrapProduct = null; // Store the current strap product for modal

  // Core utility functions
  // Reset the save button to its default state
  function setButtonState(state) {

    if(saveButton) {
      if(state === 'default') {
        saveButton.classList.remove('active');
        saveButton.querySelector('span').textContent = 'Save';
      } else if(state === 'saving') {
        saveButton.classList.add('active');
        saveButton.querySelector('span').textContent = 'Saving...';
      } else if(state === 'saved') {
        saveButton.classList.add('active');
        saveButton.querySelector('span').textContent = 'Saved!';
      }
    }
  }

  // Scroll to a specified section
  function scrollIntoView(element) {
    document.querySelector(element).scrollIntoView({
      behavior: 'smooth'
    });
  }

  // Update the URL parameters based on the active watch and strap
  function updateUrlParams(series, watchName, strap) {
    const url = new URL(window.location);
    url.searchParams.set('series', series);
    url.searchParams.set('watch', watchName);
    url.searchParams.set('strap', strap);
    window.history.pushState({}, '', url);
  }

  // UI update functions
  // Set the correct Klaviyo form ID
  function updateKlaviyoFormId(formId) {
    if (klaviyoFormCard) {
      klaviyoFormCard.classList.forEach(className => {
        if (className.startsWith('klaviyo-form-')) {
          klaviyoFormCard.classList.remove(className);
        }
      });
      klaviyoFormCard.classList.add(`klaviyo-form-${formId}`);
    }
  }

  // Update the preview images based on the active watch and strap
  function updatePreviewImages() {
    const activeWatchItem = document.querySelector('.watch-group.active .thumb-item.active');
    const activeStrapItem = document.querySelector('.strap-group.active .thumb-item.active');
    if (activeWatchItem) {
      watchPreviewImage.src = activeWatchItem.dataset.previewImage;
    }
    if (activeStrapItem) {
      strapPreviewImage.src = activeStrapItem.dataset.previewImage;
    }
    updateStrapGallery();
  }

  // Update the strap gallery images based on the active strap
  function updateStrapGallery() {
    const activeStrapItem = document.querySelector('.strap-group.active .thumb-item.active');
    if (!activeStrapItem) return;

    const activeStrapName = activeStrapItem.dataset.name;
    const strapGalleryWrappers = document.querySelectorAll('.customiser-media-strap-wrapper');
    
    // Hide all strap gallery wrappers first
    strapGalleryWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
    });
    
    // Show only the wrappers that match the active strap name
    strapGalleryWrappers.forEach(wrapper => {
      if (wrapper.getAttribute('data-name') === activeStrapName) {
        wrapper.style.display = 'block';
      }
    });
  }

  // Update the options based on the selected series
  function updateOptions(selector) {
    const selectedSeries = selector.value;

    setButtonState('default');

    // Close all open modals when series changes
    closeAllModals();

    thumbGroups.forEach(group => {
      if (group.dataset.series === selectedSeries) {
        group.classList.add('active');
      } else {
        group.classList.remove('active');
      }
    });

    activeWatchID = document.querySelector('.watch-group.active .thumb-item.active')?.dataset.id;
    activeStrapID = document.querySelector('.strap-group.active .thumb-item.active')?.dataset.id;
    activeSeries = selectedSeries;

    const activeWatchNameSlug = document.querySelector('.watch-group.active .thumb-item.active').dataset.nameSlug;
    const activeStrapNameSlug = document.querySelector('.strap-group.active .thumb-item.active').dataset.nameSlug;
    const formId = selector.options[selector.selectedIndex].getAttribute('form-id');
    updateUrlParams(selectedSeries, activeWatchNameSlug, activeStrapNameSlug);
    updateKlaviyoFormId(formId);
    updatePreviewImages();
    updateCartCount();
    updateTechSpecsVisibility(selectedSeries);
  }

  // Update tech-specs sections visibility based on selected series
  function updateTechSpecsVisibility(selectedSeries) {
    console.log('selectedSeries', selectedSeries);
    const techSpecsSections = document.querySelectorAll('.tech-specs-section');
    
    techSpecsSections.forEach(section => {
      const sectionSeries = section.getAttribute('data-series');
      
      if (sectionSeries && sectionSeries !== selectedSeries) {
        // Hide sections that don't match the selected series
        section.style.display = 'none';
      } else if (sectionSeries && sectionSeries === selectedSeries) {
        // Show sections that match the selected series
        section.style.display = 'block';
      } else if (!sectionSeries) {
        // Show sections without a data-series attribute (they should always be visible)
        section.style.display = 'block';
      }
    });
  }

  // Event listeners
  thumbItems.forEach(item => {
    item.addEventListener('click', function() {
      
      const siblings = this.parentElement.querySelectorAll('.thumb-item');
      
      siblings.forEach(sibling => {
        sibling.classList.remove('active');
      });
      
      this.classList.add('active');
      
      activeWatchID = document.querySelector('.watch-group.active .thumb-item.active')?.dataset.id;
      activeStrapID = document.querySelector('.strap-group.active .thumb-item.active')?.dataset.id;
      activeSeries = seriesSelector.value;
      
      const activeWatchNameSlug = document.querySelector('.watch-group.active .thumb-item.active').dataset.nameSlug;
      const activeStrapNameSlug = document.querySelector('.strap-group.active .thumb-item.active').dataset.nameSlug;
      
      updateUrlParams(seriesSelector.value, activeWatchNameSlug, activeStrapNameSlug);
      updatePreviewImages();
      setButtonState('default');
      updateCartCount();
    });
  });

  // Update the options based on the selected series
  seriesSelector.addEventListener('change', function() {
    updateOptions(this);
  });

  // Function to calculate and update total price of selected straps
  function updateStrapTotalPrice() {
    const totalPriceElement = document.querySelector('.strap-total-price');
    if (!totalPriceElement) return;
    const checkedStrapItems = document.querySelectorAll('.strap-group.active .thumb-item > input:checked');
    let totalPrice = 0;
    checkedStrapItems.forEach(checkbox => {
      const strapItem = checkbox.closest('.thumb-item');
      const strapId = strapItem.getAttribute('data-id');
      
      // Find the select for this strap and get the price from the selected option
      const select = document.getElementById(`strap-size-selector-${strapId}`);
      // if (select) {
      //   const selectedOption = select.options[select.selectedIndex];
      //   if (selectedOption) {
      //     const priceString = selectedOption.getAttribute('data-price');
      //     const priceNumber = parseFloat(priceString.replace(/[^0-9.]/g, ''));
      //     if (!isNaN(priceNumber)) {
      //       totalPrice += priceNumber;
      //     }
      //   }
      // }
    });
    const formattedPrice = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(totalPrice);
    totalPriceElement.textContent = formattedPrice;
  }

  // Add to cart
  function updateCartCount() {
    // Count all checked strap checkboxes
    const checkedStrapItems = document.querySelectorAll('.strap-group.active .thumb-item > input:checked');
    const count = checkedStrapItems.length;
    
    if (buttonCartCount) {
      buttonCartCount.textContent = count;
    }
    
    const addToCartButton = document.querySelector('#add-customiser-products-to-cart');
    if (addToCartButton) {
      if (count === 0) {
        addToCartButton.setAttribute('disabled', 'disabled');
      } else {
        addToCartButton.removeAttribute('disabled');
      }
    }

    // Update the total price
    updateStrapTotalPrice();
  }

  // Replace the prevSelections forEach with event delegation
  if (prevSelectionsSection) {
    prevSelectionsSection.addEventListener('click', function(event) {
      const selection = event.target.closest('.previous-selection-item');
      if (!selection) return;

      const watchID = selection.dataset.watchId;
      const strapID = selection.dataset.strapId;
      const series = selection.dataset.series;

      activeWatchID = watchID;
      activeStrapID = strapID;
      activeSeries = series;

      // Set the series selector to the active series
      seriesSelector.value = activeSeries;
      updateOptions(seriesSelector);

      // Force click the items from the previous selection
      document.querySelector('.watch-group .thumb-item[data-id="' + watchID + '"]').click();
      document.querySelector('.strap-group .thumb-item[data-id="' + strapID + '"]').click();

      if(event.target.closest('.remove-selection-btn') || event.target.closest('.quick-add-to-cart-btn')) {
        return;
      }

      scrollIntoView('.customiser-wrapper');
    });
  }

  // Add this after the other event listeners, before the URL parameter initialization
  if (customiserInspirationItems) {
    customiserInspirationItems.forEach(item => {
      item.addEventListener('click', function(event) {
        // Only proceed if clicking the tooltip or view-in-previewer
        if (!event.target.closest('.tooltip') && !event.target.closest('.view-in-previewer')) {
          return;
        }
        
        const series = this.dataset.series;
        const watchHandle = this.dataset.watch;
        const strapHandle = this.dataset.strap;

        // Set the series selector
        seriesSelector.value = series;
        updateOptions(seriesSelector);

        // Find and click the matching watch and strap items
        const watchItem = document.querySelector(`.watch-group.active .thumb-item[data-name-slug="${watchHandle}"]`);
        const strapItem = document.querySelector(`.strap-group.active .thumb-item[data-name-slug="${strapHandle}"]`);

        if (watchItem) watchItem.click();
        if (strapItem) strapItem.click();

        scrollIntoView('.customiser-wrapper');
      });
    });
  }

  // Initialize selections based on URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const initialSeries = urlParams.get('series');
  const initialWatch = urlParams.get('watch');
  const initialStrap = urlParams.get('strap');

  if (initialSeries) {
    seriesSelector.value = initialSeries;
    updateOptions(seriesSelector);
  } else {
    const defaultSeries = seriesSelector.value;
    activeWatchID = document.querySelector('.watch-group.active .thumb-item.active')?.dataset.id;
    activeStrapID = document.querySelector('.strap-group.active .thumb-item.active')?.dataset.id;
    const defaultWatchNameSlug = document.querySelector('.watch-group.active .thumb-item.active').dataset.nameSlug;
    const defaultStrapNameSlug = document.querySelector('.strap-group.active .thumb-item.active').dataset.nameSlug;
    const formId = seriesSelector.options[seriesSelector.selectedIndex].getAttribute('form-id');
    updateUrlParams(defaultSeries, defaultWatchNameSlug, defaultStrapNameSlug);
    updateKlaviyoFormId(formId);
    updatePreviewImages();
    updateCartCount();
    updateTechSpecsVisibility(defaultSeries);
  }

  if (initialWatch) {
    const initialWatchItem = document.querySelector(`.watch-group.active .thumb-item[data-name-slug="${initialWatch}"]`);
    if (initialWatchItem) {
      initialWatchItem.click();
    }
  }

  if (initialStrap) {
    const initialStrapItem = document.querySelector(`.strap-group.active .thumb-item[data-name-slug="${initialStrap}"]`);
    if (initialStrapItem) {
      initialStrapItem.click();
    }
  }

  // Initialize price calculator
  updateStrapTotalPrice();

  // Functions
  // - Basic fetch request to the API
  // - Update the previous selections section
  // - Create a metaobject
  // - Fetch the customers metafield existing values
  // - Add to the customers metafield values
  // - Remove from the customers metafield values
  // - Update the customers metafield with the new values

  // Save to wishlist
  if(customerID) {
    const currentUrl = window.location.href;
    let apiUrl;

    if(currentUrl.includes('sp-underd0g')) {
      apiUrl = 'https://4c1t05mm5f.execute-api.us-east-1.amazonaws.com/underdog-customiser';
    } else {
      apiUrl = 'https://13s0dypl1i.execute-api.us-east-1.amazonaws.com/underdog-customiser-production';
    }

    const fetchCustomer = `gid://shopify/Customer/${customerID}`;
    
    async function fetchRequest(query, variables) {
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ query, variables })
        });

        const result = await response.json();

        if(result.errors) {
          throw new Error(result.errors.map(error => error.message).join(', '));
        }

        return result;
      } catch (error) {
        console.error('GraphQL request failed:', error);
        throw error;
      }
    }

    // Function to fetch the previous selections section
    async function fetchPreviousSelectionsSection(sectionID) {
      const response = await fetch(`/?section_id=customer-prev-selections`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return response;
    }

    // Function to handle updating the previous selections section
    function updatePreviousSelectionsSection(html, sectionId) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.getElementById(sectionId);

      if (newSection) {
        const oldSection = document.getElementById(sectionId);
        oldSection.innerHTML = newSection.innerHTML;
      }
    }

    // Function to handle creating the metaobject
    async function createMetaobject({ type, watch, strap, series }) {
      const query = `
          mutation CreateMetaobject($metaobject: MetaobjectCreateInput!) {
            metaobjectCreate(metaobject: $metaobject) {
              metaobject {
                id
                type
                handle
                fields {
                  key
                  value
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `;

        const variables = {
          metaobject: {
            type: type, 
            fields: [
              { key: "watch", value: watch },
              { key: "strap", value: strap },
              { key: "series", value: series }
            ]
          }
        };

        const response = await fetchRequest(query, variables);
        
        return response.data.metaobjectCreate.metaobject;
    }

    // Function to handle fetching the metafield
    async function fetchCustomerMetafieldValue(metaobjectId) {
      const getCurrentMetafield = `
        query getCustomerMetafield($customerId: ID!) {
          customer(id: $customerId) {
            metafield(namespace: "custom", key: "customised_watches") {
              value
            }
          }
        }
      `;

      const customerId = fetchCustomer;
      const response = await fetchRequest(getCurrentMetafield, { customerId });
      
      // Handle case where metafield doesn't exist yet
      if (!response.data.customer.metafield) {
        return '[]';
      }

      return response.data.customer.metafield.value;
    }

    // Function to handle updating the metafield
    async function updateCustomerMetafield(newValues) {
      const query = `
        mutation updateCustomerMetafield($metafields: [MetafieldsSetInput!]!) {
          metafieldsSet(metafields: $metafields) {
            metafields {
              id
              value
            }
          }
        }
      `;

      const variables = {
        metafields: [
          {
            ownerId: fetchCustomer,
            namespace: "custom",
            key: "customised_watches",
            type: "list.metaobject_reference",
            value: JSON.stringify(newValues)
          }
        ]
      };

      const response = await fetchRequest(query, variables);
      return response.data.metafieldsSet.metafields;
    }

    // Function to handle adding to the metafield
    async function addToCustomerMetafield(newMetaobject) {
      const currentMetafieldValue = await fetchCustomerMetafieldValue(newMetaobject.id);
      // Parse the value, defaulting to empty array if it's null/undefined
      const existingValues = JSON.parse(currentMetafieldValue || '[]');
      const updatedValues = [newMetaobject, ...existingValues];
      
      const updateResponse = await updateCustomerMetafield(updatedValues);
      return updateResponse;
    }

    // Function to handle removing from the metafield
    async function removeCustomerMetafieldItem(indexToRemove) {
      const getCustomerCurrentMetafieldValue = await fetchCustomerMetafieldValue();
      const existingValues = JSON.parse(getCustomerCurrentMetafieldValue || '[]');
      const updatedValues = existingValues.filter((_, index) => index !== indexToRemove);
      
      const updateResponse = await updateCustomerMetafield(updatedValues);
      return updateResponse;
    }

    // Handle removing from the wishlist
    document.addEventListener('click', async(event) => {
      if(event.target.closest('.remove-selection-btn')) {
        event.stopPropagation();

        const previousSelectionItem = event.target.closest('.previous-selection-item');
        const indexToRemove = previousSelectionItem.getAttribute('data-index') - 1;

        if(previousSelectionItem) {
          previousSelectionItem.style.display = 'none';
        }

        setButtonState('default');
        
        try {
          const updateResponse = await removeCustomerMetafieldItem(indexToRemove);

          if(updateResponse) {
            const sectionId = 'customer-prev-selections';
            const response = await fetchPreviousSelectionsSection(sectionId);

            if(response.ok) {
              setButtonState('default');

              const html = await response.text();
              updatePreviousSelectionsSection(html, sectionId);
            }
          }
        } catch(error) {
          alert('Error removing from wishlist:', error);
        }
      }
    });

    // Handle savings to the wishlist
    if(saveButton) {
      saveButton.addEventListener('click', async () => {
        setButtonState('saving');
  
        try {
          const newMetaobject = await createMetaobject({
            type: "customiser_group",
            watch: `gid://shopify/Product/${activeWatchID}`,
            strap: `gid://shopify/Product/${activeStrapID}`,
            series: activeSeries
          });
  
          // const updateResponse = await fetchCustomerMetafieldValue(response.id);
          const updateResponse = await addToCustomerMetafield(newMetaobject.id);
  
          if(updateResponse) {
            const sectionId = 'customer-prev-selections';
            const response = await fetchPreviousSelectionsSection(sectionId);
  
            if(response.ok) {
              setButtonState('saved');
  
              const html = await response.text();
              updatePreviousSelectionsSection(html, sectionId);
  
              scrollIntoView('#customer-prev-selections');
            }
          }
        } catch (error) {
          alert('Error saving to wishlist:', error);
          setButtonState('default');
        }
      });
    }
  }

  // Function to close all open modals
  function closeAllModals() {
    const allModals = document.querySelectorAll('.modal-wrapper');
    allModals.forEach(modal => {
      const overlay = modal.querySelector('.modal-overlay');
      const card = modal.querySelector('.modal-card');
      if (overlay) overlay.classList.remove('modal-open');
      if (card) card.classList.remove('modal-open');
    });
  }

  // Event listeners for modal
  // Note: modal.js already handles close functionality for .close-modal and .modal-overlay

  // Close modal on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeAllModals();
    }
  });

  // Open the correct modal for each strap
  document.addEventListener('click', function(event) {
    const addBtn = event.target.closest('.icon-bubble-add');
    if (addBtn) {
      const strapId = addBtn.getAttribute('data-strap-id');
      if (strapId) {
        // Find the closest thumb-item parent and then find the modal that's a sibling
        const thumbItem = addBtn.closest('.thumb-item');
        if (thumbItem) {
          // Store a reference to the clicked thumb item on the modal for later use
          const modalTarget = `strap-variant-modal-${strapId}`;
          // Look for the modal in the same strap-group (parent of thumb-item)
          const strapGroup = thumbItem.closest('.strap-group');
          if (strapGroup) {
            const modalWrapper = strapGroup.querySelector(`[data-modal='${modalTarget}']`);
            
            if (modalWrapper) {
              // Store the clicked thumb item reference on the modal
              modalWrapper.setAttribute('data-clicked-thumb-item-id', thumbItem.dataset.id);
              modalWrapper.setAttribute('data-clicked-thumb-item-series', strapGroup.dataset.series);
              
              const modalOverlay = modalWrapper.querySelector('.modal-overlay');
              const modalCard = modalWrapper.querySelector('.modal-card');
              if (modalOverlay && modalCard) {
                modalOverlay.classList.add('modal-open');
                modalCard.classList.add('modal-open');
              }
            }
          }
        }
      }
    }
  });

  // Handle modal selector changes to update input value in real-time
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('strap-variant-selector')) {
      const modalWrapper = event.target.closest('.modal-wrapper');
      if (modalWrapper) {
        // Get the stored reference to the clicked thumb item
        const clickedThumbItemId = modalWrapper.getAttribute('data-clicked-thumb-item-id');
        const clickedThumbItemSeries = modalWrapper.getAttribute('data-clicked-thumb-item-series');
        
        if (clickedThumbItemId && clickedThumbItemSeries) {
          // Find the specific thumb item that was clicked
          const thumbItem = document.querySelector(`.strap-group[data-series="${clickedThumbItemSeries}"] .thumb-item[data-id="${clickedThumbItemId}"]`);
          if (thumbItem) {
            // Find the input within this thumb item
            const input = thumbItem.querySelector('input[type="checkbox"]');
            if (input) {
              input.value = event.target.value;
            }
          }
        }
      }
    }
  });

  // Handle select strap variant from modal
  document.addEventListener('click', function(event) {
    const selectBtn = event.target.closest('.select-strap-variant');
    if (selectBtn) {
      event.preventDefault();
      const strapId = selectBtn.getAttribute('data-strap-id');
      const select = document.getElementById(`strap-size-selector-${strapId}`);
      if (select) {
        // Find the modal wrapper to get the clicked thumb item reference
        const modalWrapper = selectBtn.closest('.modal-wrapper');
        if (modalWrapper) {
          const clickedThumbItemId = modalWrapper.getAttribute('data-clicked-thumb-item-id');
          const clickedThumbItemSeries = modalWrapper.getAttribute('data-clicked-thumb-item-series');
          
          // Find the specific thumb item that was clicked using the stored reference
          const strapItem = document.querySelector(`.strap-group[data-series="${clickedThumbItemSeries}"] .thumb-item[data-id="${clickedThumbItemId}"]`);
          
          if (strapItem) {
            // Only check the input and add 'active', do NOT set the value again
            const checkbox = strapItem.querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.checked = true;
              strapItem.classList.add('active');
            }
          }
          
          // Close the modal
          const modalOverlay = modalWrapper.querySelector('.modal-overlay');
          const modalCard = modalWrapper.querySelector('.modal-card');
          if (modalOverlay && modalCard) {
            modalOverlay.classList.remove('modal-open');
            modalCard.classList.remove('modal-open');
          }
        }
      }
      updateCartCount();
      updateStrapTotalPrice();
    }
  });

  // Handle deselection via trash icon
  document.addEventListener('click', function(event) {
    const trashIcon = event.target.closest('.fa-trash');
    if (trashIcon) {
      event.preventDefault();
      event.stopPropagation();
      
      // Find the closest thumb-item that contains this trash icon
      const thumbItem = trashIcon.closest('.thumb-item');
      if (thumbItem) {
        const checkbox = thumbItem.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = false;
          thumbItem.classList.remove('active');
          updateCartCount();
          updateStrapTotalPrice();
        }
      }
    }
  });

  // Handle direct checkbox clicks for toggling
  document.addEventListener('change', function(event) {
    if (event.target.type === 'checkbox' && event.target.name === 'strap-selector') {
      const thumbItem = event.target.closest('.thumb-item');
      if (thumbItem) {
        if (event.target.checked) {
          thumbItem.classList.add('active');
        } else {
          thumbItem.classList.remove('active');
        }
        updateCartCount();
        updateStrapTotalPrice();
      }
    }
  });

  // Lightbox functionality
  function createLightbox() {
    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.innerHTML = `
      <div class="lightbox-overlay"></div>
      <div class="lightbox-content">
        <button class="lightbox-close">&times;</button>
        <div class="lightbox-controls">
          <button class="icon-bubble small-icon-bubble primary lightbox-zoom-in" title="Zoom In">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button class="icon-bubble small-icon-bubble primary lightbox-zoom-out" title="Zoom Out">
            <i class="fa-solid fa-minus"></i>
          </button>
          <button class="icon-bubble small-icon-bubble primary lightbox-reset" title="Reset Zoom">
            <i class="fa-solid fa-arrows-rotate"></i>
          </button>
        </div>
        <div class="lightbox-images-container">
          <img class="lightbox-image lightbox-strap-image" src="" alt="">
          <img class="lightbox-image lightbox-watch-image" src="" alt="">
        </div>
      </div>
    `;
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function showLightbox(imageSrc, imageAlt, isMainWrapper = false) {
    const lightbox = document.querySelector('.lightbox') || createLightbox();
    const lightboxOverlay = lightbox.querySelector('.lightbox-overlay');
    const closeBtn = lightbox.querySelector('.lightbox-close');
    const lightboxImagesContainer = lightbox.querySelector('.lightbox-images-container');
    const lightboxWatchImage = lightbox.querySelector('.lightbox-watch-image');
    const lightboxStrapImage = lightbox.querySelector('.lightbox-strap-image');
    const zoomInBtn = lightbox.querySelector('.lightbox-zoom-in');
    const zoomOutBtn = lightbox.querySelector('.lightbox-zoom-out');
    const resetBtn = lightbox.querySelector('.lightbox-reset');

    // Reset zoom state
    let currentZoom = 1;
    const minZoom = 0.5;
    const maxZoom = 3;
    const zoomStep = 0.25;

    // Pan state
    let isPanning = false;
    let startX = 0;
    let startY = 0;
    let currentPanX = 0;
    let currentPanY = 0;
    let lastPanX = 0;
    let lastPanY = 0;

    function updateTransform() {
      lightboxImagesContainer.style.transform = `scale(${currentZoom}) translate(${currentPanX}px, ${currentPanY}px)`;
      lightboxImagesContainer.style.transformOrigin = 'center center';
    }

    function updateZoom() {
      updateTransform();
    }

    function resetPan() {
      currentPanX = 0;
      currentPanY = 0;
      lastPanX = 0;
      lastPanY = 0;
      updateTransform();
    }

    function zoomIn() {
      if (currentZoom < maxZoom) {
        currentZoom += zoomStep;
        updateZoom();
        // Reset pan when zooming to keep image centered
        resetPan();
        updateCursor();
      }
    }

    function zoomOut() {
      if (currentZoom > minZoom) {
        currentZoom -= zoomStep;
        updateZoom();
        // Reset pan when zooming to keep image centered
        resetPan();
        updateCursor();
      }
    }

    function resetZoom() {
      currentZoom = 1;
      resetPan();
      updateZoom();
      updateCursor();
    }

    // Pan event listeners
    lightboxImagesContainer.addEventListener('mousedown', function(e) {
      if (currentZoom > 1) {
        isPanning = true;
        startX = e.clientX - lastPanX;
        startY = e.clientY - lastPanY;
        lightboxImagesContainer.style.cursor = 'grabbing';
        e.preventDefault();
      }
    });

    document.addEventListener('mousemove', function(e) {
      if (isPanning && currentZoom > 1) {
        currentPanX = e.clientX - startX;
        currentPanY = e.clientY - startY;
        updateTransform();
        e.preventDefault();
      }
    });

    document.addEventListener('mouseup', function() {
      if (isPanning) {
        isPanning = false;
        lastPanX = currentPanX;
        lastPanY = currentPanY;
        lightboxImagesContainer.style.cursor = currentZoom > 1 ? 'grab' : 'default';
      }
    });

    // Touch pan for mobile
    lightboxImagesContainer.addEventListener('touchstart', function(e) {
      if (e.touches.length === 1 && currentZoom > 1) {
        isPanning = true;
        startX = e.touches[0].clientX - lastPanX;
        startY = e.touches[0].clientY - lastPanY;
        e.preventDefault();
      }
    });

    lightboxImagesContainer.addEventListener('touchmove', function(e) {
      if (e.touches.length === 1 && isPanning && currentZoom > 1) {
        currentPanX = e.touches[0].clientX - startX;
        currentPanY = e.touches[0].clientY - startY;
        updateTransform();
        e.preventDefault();
      } else if (e.touches.length === 2) {
        // Pinch to zoom (existing code)
        e.preventDefault();
        const currentDistance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        
        if (initialDistance > 0) {
          const scale = currentDistance / initialDistance;
          currentZoom = Math.max(minZoom, Math.min(maxZoom, initialZoom * scale));
          updateZoom();
          resetPan();
        }
      }
    });

    lightboxImagesContainer.addEventListener('touchend', function(e) {
      if (isPanning) {
        isPanning = false;
        lastPanX = currentPanX;
        lastPanY = currentPanY;
      }
    });

    // Update cursor based on zoom level
    function updateCursor() {
      lightboxImagesContainer.style.cursor = currentZoom > 1 ? 'grab' : 'default';
    }

    // Zoom event listeners
    zoomInBtn.onclick = zoomIn;
    zoomOutBtn.onclick = zoomOut;
    resetBtn.onclick = resetZoom;

    // Mouse wheel zoom
    lightboxImagesContainer.addEventListener('wheel', function(e) {
      e.preventDefault();
      if (e.deltaY < 0) {
        zoomIn();
      } else {
        zoomOut();
      }
    });

    // Touch gestures for mobile
    let initialDistance = 0;
    let initialZoom = 1;

    lightboxImagesContainer.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        initialDistance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        initialZoom = currentZoom;
      }
    });

    lightboxImagesContainer.addEventListener('touchmove', function(e) {
      if (e.touches.length === 1 && isPanning && currentZoom > 1) {
        currentPanX = e.touches[0].clientX - startX;
        currentPanY = e.touches[0].clientY - startY;
        updateTransform();
        e.preventDefault();
      } else if (e.touches.length === 2) {
        // Pinch to zoom (existing code)
        e.preventDefault();
        const currentDistance = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        
        if (initialDistance > 0) {
          const scale = currentDistance / initialDistance;
          currentZoom = Math.max(minZoom, Math.min(maxZoom, initialZoom * scale));
          updateZoom();
          resetPan();
        }
      }
    });

    lightboxImagesContainer.addEventListener('touchend', function(e) {
      if (isPanning) {
        isPanning = false;
        lastPanX = currentPanX;
        lastPanY = currentPanY;
      }
    });

    // Update cursor based on zoom level
    function updateCursor() {
      lightboxImagesContainer.style.cursor = currentZoom > 1 ? 'grab' : 'default';
    }

    if (isMainWrapper) {
      // Show both images overlaid for main wrapper
      const mainWrapper = document.querySelector('.customiser-media-wrapper');
      const watchImg = mainWrapper.querySelector('.watch-preview');
      const strapImg = mainWrapper.querySelector('.strap-preview');
      
      if (watchImg && watchImg.src) {
        lightboxWatchImage.src = watchImg.src;
        lightboxWatchImage.alt = watchImg.alt || 'Watch Preview';
        lightboxWatchImage.style.display = 'block';
      }
      
      if (strapImg && strapImg.src) {
        lightboxStrapImage.src = strapImg.src;
        lightboxStrapImage.alt = strapImg.alt || 'Strap Preview';
        lightboxStrapImage.style.display = 'block';
      }
      
      lightboxImagesContainer.style.position = 'relative';
    } else {
      // Show single image for strap gallery
      lightboxWatchImage.style.display = 'none';
      lightboxStrapImage.src = imageSrc;
      lightboxStrapImage.alt = imageAlt;
      lightboxStrapImage.style.display = 'block';
      lightboxImagesContainer.style.position = 'static';
    }

    // Reset zoom when opening
    resetZoom();
    updateCursor();
    lightbox.style.display = 'flex';

    // Close lightbox functions
    const closeLightbox = () => {
      lightbox.style.display = 'none';
    };

    closeBtn.onclick = closeLightbox;
    lightboxOverlay.onclick = closeLightbox;

    // Close on escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
  }

  // Add click handlers to media wrappers
  function initLightboxHandlers() {
    // Main preview wrapper (watch + strap overlay)
    const mainMediaWrapper = document.querySelector('.customiser-media-wrapper');
    if (mainMediaWrapper) {
      mainMediaWrapper.style.cursor = 'pointer';
      mainMediaWrapper.addEventListener('click', function() {
        showLightbox(null, null, true); // Pass true to indicate main wrapper
      });
    }

    // Strap gallery wrappers
    const strapWrappers = document.querySelectorAll('.customiser-media-strap-wrapper');
    strapWrappers.forEach(wrapper => {
      wrapper.style.cursor = 'pointer';
      wrapper.addEventListener('click', function() {
        const img = this.querySelector('img');
        if (img && img.src) {
          showLightbox(img.src, img.alt || 'Strap Gallery Image', false);
        }
      });
    });
  }

  // Initialize lightbox handlers
  // initLightboxHandlers();

  // Re-initialize lightbox handlers when strap gallery updates
  const originalUpdateStrapGallery = updateStrapGallery;
  updateStrapGallery = function() {
    originalUpdateStrapGallery.call(this);
    // initLightboxHandlers();
  };
});

